import axiosService from '../services/axiosService';

const LIST_URL = {
    SEND: '/WebApi/V1/Contact/Send',
};

const contactApis = {
    send: (dataPost) => {
        return axiosService.post(LIST_URL.SEND, dataPost);
    },
};

export default contactApis;
